import { KpiSetElement, TemplateElement, TemplateSection } from '../model';

/**
 * Determine the visibility of template elements.
 */
export const determineTemplateElementVisibility = (
    templateSections: TemplateSection[],
): TemplateSection[] => {
    // Determine all KPI set elements.
    const kpiSetElements: KpiSetElement[] = filterKPISetElements(templateSections);

    // Determine visibility of template elements.
    templateSections.forEach((section: TemplateSection) => {
        section.elements.forEach((element: TemplateElement) => {
            if (element instanceof KpiSetElement) {
                // Determine visibility for KPI set elements.
                element.visible = true;
            } else {
                // Determine visibility for other element types.
                const isPartOfKpiSet = kpiSetElements.some((kpiSet: KpiSetElement) =>
                    kpiSet.linkedVisuals.some((v) => v.visualId === element.id),
                );
                element.visible = !isPartOfKpiSet;
            }
        });
        section.elements = [...section.elements];
    });

    return templateSections;
};

export const assignTitleIfKPISetTitleShouldBeShown = (
    templateSections: TemplateSection[],
): TemplateSection[] => {
    const kpiSetElements: KpiSetElement[] = filterKPISetElements(templateSections);

    const clonedTemplateSections = templateSections.map((section) => ({
        ...section,
        elements: [...section.elements],
    }));

    clonedTemplateSections.forEach((section: TemplateSection) => {
        section.elements.forEach((element: TemplateElement) => {
            const isPartOfKpiSet = kpiSetElements.some((kpiSet: KpiSetElement) =>
                kpiSet.linkedVisuals.some((v) => v.visualId === element.id),
            );
            element.useTitle = isPartOfKpiSet;
        });
    });
    return clonedTemplateSections;
};

export const filterKPISetElements = (templateSections: TemplateSection[]): KpiSetElement[] => {
    const kpiSetElements: KpiSetElement[] = [];

    templateSections.forEach((section: TemplateSection) => {
        section.elements.forEach((element: TemplateElement) => {
            if (element instanceof KpiSetElement) {
                kpiSetElements.push(element);
            }
        });
    });

    return kpiSetElements;
};
